








































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatePicker extends Vue {
  @Model("change") value?: string[] | string;
  @Prop({ default: "general.dates.select_date" }) label!: string;
  @Prop({ default: "DD/MM/YYYY" }) format!: string;
  @Prop({ default: false }) range!: boolean;
  @Prop({ default: "date" }) type!: string;
  @Prop() min: Date | undefined;
  @Prop() max: Date | undefined;
  menu = false;
  date?: string[] | string = "";

  created(): void {
    this.date = this.value;
  }

  get formattedDate(): string {
    if (!this.range) {
      return this.date ? moment(this.date).format(this.format) : "";
    } else {
      if (this.date && this.date.length > 1) {
        const a = moment(this.date[0]);
        const b = moment(this.date[1]);
        if (a > b) {
          return `${b.format(this.format)} - ${a.format(this.format)}`;
        } else {
          return `${a.format(this.format)} - ${b.format(this.format)}`;
        }
      }
      return "";
    }
  }

  @Watch("date")
  emit(): void {
    if (this.range && this.date && this.date.length > 1) {
      const a = moment(this.date[0]);
      const b = moment(this.date[1]);
      a > b
        ? this.$emit("change", [b.format(), a.format()])
        : this.$emit("change", [a.format(), b.format()]);
    } else {
      this.$emit("change", moment(this.date).format());
    }
  }
}
